/* ZSportsTech — section-gauges.js
   Scoped to #sc-clrep. Vanilla JS only, namespaced.
   On enter-view: animate each gold arc 0→arc_pct and count-up each value.
   Maps to → assets/section-gauges.js in Shopify theme.
   ─────────────────────────────────────────────────── */
(function () {
  'use strict';

  var sec = document.getElementById('sc-clrep');
  if (!sec) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fills  = [].slice.call(sec.querySelectorAll('.gauge__fill[data-arc]'));
  var values = [].slice.call(sec.querySelectorAll('.gauge__value[data-count]'));

  /* Set the resting (final) state — used directly for reduced motion. */
  function settle() {
    fills.forEach(function (p) {
      var pct = parseFloat(p.getAttribute('data-arc')) || 0;
      p.style.strokeDashoffset = String(100 - pct);
    });
    values.forEach(function (v) {
      v.textContent = v.getAttribute('data-count');
    });
  }

  if (reduce || document.visibilityState === 'hidden') { settle(); return; }

  /* Base HTML already shows final values + filled arcs (capture/print-safe).
     We only reset-then-animate when the section actually scrolls into view. */

  function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }

  function countUp(el) {
    var target = parseInt(el.getAttribute('data-count'), 10);
    if (isNaN(target)) return;
    var dur = 1200, start = null;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      el.textContent = String(Math.round(target * easeOutCubic(p)));
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = String(target);
    }
    requestAnimationFrame(step);
  }

  function run() {
    /* Arcs: snap empty (no transition), then transition to the filled value. */
    fills.forEach(function (p, i) {
      var pct = parseFloat(p.getAttribute('data-arc')) || 0;
      p.style.transition = 'none';
      p.style.strokeDashoffset = '100';
      void p.getBoundingClientRect();
      p.style.transition = 'stroke-dashoffset 1.2s cubic-bezier(0,0,0.2,1) ' + (i * 0.08) + 's';
      p.style.strokeDashoffset = String(100 - pct);
    });
    values.forEach(function (v) { countUp(v); });
  }

  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { run(); obs.disconnect(); }
      });
    }, { threshold: 0.3 });
    obs.observe(sec.querySelector('.sc-clrep__gauges') || sec);
  } else {
    settle();
  }
}());
